
import { ArrowRight } from 'lucide-react';
import G2RatingVisual from './G2RatingVisual';
import FireText from './FireText';

const HeroTextContent = () => {
  return <div className="animate-fade-in flex flex-col h-full">
      <div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-cs-dark-grey leading-tight mb-2">
          Don't let your reqs turn into <FireText text="emergencies" className="font-bold" />
        </h1>
        <h2 className="text-xl md:text-2xl text-cs-dark-grey mb-8 leading-snug">
          Your deadlines demand both speed and quality — conventional vendors deliver neither.
          <br /><br />
          Cutshort blends a 3.5M-strong premium tech talent pool with AI and expert curation to help you close critical roles on time, every time.
        </h2>
        <a href="https://cutshort.io/a/cxo-abm" target="_blank" rel="noopener noreferrer" className="bg-cs-primary hover:bg-cs-primary/90 text-white text-lg px-8 py-6 rounded-md flex items-center gap-2 inline-flex">
          Get 5 sample profiles in next 24 hours
          <ArrowRight className="h-5 w-5" />
        </a>
        
        {/* New guarantee text with link */}
        <div className="mt-4 text-cs-dark-grey/90 text-md">
          If you don't make an offer from first 7 candidates, we owe you $250 &nbsp;
          <a href="#cta-section" className="text-cs-primary font-medium underline hover:text-cs-primary/80">
            What's this?
          </a>
        </div>
      </div>
      
      {/* Stats line with updated G2 rating line without stars */}
      <div className="mt-auto text-cs-dark-grey/80 text-xl md:text-2xl font-medium pt-8 md:pt-0 flex flex-wrap items-center gap-2">
        <span>3.5 Million users</span>
        <span className="mx-1">|</span>
        <span>40,000+ recruiters</span>
        <span className="mx-1">|</span>
        <span className="flex items-center gap-1">
          Rated <span className="ml-1 font-semibold">4.7</span> on
          <img src="/lovable-uploads/eff70dcb-ba99-4c57-b3c6-7b58b91dff38.png" alt="G2" className="inline-block h-5 w-5 ml-1" style={{
          borderRadius: 3
        }} loading="lazy" decoding="async" />
        </span>
      </div>
    </div>;
};

export default HeroTextContent;
